/**
 * Âge d'une sélection enregistrée dans le navigateur (« il y a 2 jours », « il y a 3 heures »), toujours en
 * nombre (jamais « avant-hier »), comme le bandeau de la spec. Seule mesure faite côté client : l'horodatage
 * vient du stockage local, aucune date serveur n'est formatée.
 */
export function formatRelativeAge(timestamp: number, now: number, locale: string): string {
  const format = new Intl.RelativeTimeFormat(locale, { numeric: 'always' });
  const minutes = Math.max(1, Math.round((now - timestamp) / 60_000));
  if (minutes < 60) return format.format(-minutes, 'minute');
  const hours = Math.round(minutes / 60);
  if (hours < 24) return format.format(-hours, 'hour');
  return format.format(-Math.round(hours / 24), 'day');
}
